import "#legacy/shared/jquery_ui_sortable.js";
import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.List = class List extends AssessmentBuilder.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.buildList = this.buildList.bind(this);
    this.buildListItem = this.buildListItem.bind(this);
    this.makeSortable = this.makeSortable.bind(this);
    this.updatePositions = this.updatePositions.bind(this);
    this.unselectAll = this.unselectAll.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.markSelected = this.markSelected.bind(this);
  }

  initialize(options = {}) {
    super.initialize(options);
    if (options.sortable) {
      return this.makeSortable();
    }
  }

  render() {
    this.containers = this.buildList();

    _.each(this.selected, (question) => this.markSelected(question));

    this.$el.html(this.containers);
    return this;
  }

  // HELPER FUNCTIONS

  buildList() {
    let containers = jQuery();

    this.collection.each((model, index) => {
      const container = jQuery(`<div class='${this.listItemCssClass}'></div>`);
      container.append(this.buildListItem(model));
      container.data("model", model);
      return (containers = containers.add(container));
    });

    return containers;
  }

  buildListItem(model) {
    const klass = eval(this.listItemViewClass);
    const view = new klass({
      model,
      selectItems: this.selectItems,
    });

    return view.render().el;
  }

  makeSortable() {
    return this.$el.sortable({
      axis: "y",
      cancel: "input,textarea,button,select,option,sp-select",
      items: `.${this.listItemCssClass}`,
      update: this.updatePositions.bind(this),
    });
  }

  updatePositions() {
    this.$(`.${this.listItemCssClass}`).each((index, element) =>
      jQuery(element).data("model").set({ position: index }),
    );
    return this.collection.sort();
  }

  unselectAll() {
    const count = this.selected.length;
    jQuery(this.containers).filter(`.${this.selectedCss}`).removeClass(this.selectedCss);
    this.selected = [];
    return count;
  }

  selectItem(item) {
    this.selected.push(item);
    return this.markSelected(item);
  }

  markSelected(item) {
    return jQuery(this.containers).each((_, container) => {
      container = jQuery(container);
      if (container.data("model") === item) {
        container.addClass(this.selectedCss);
        return false;
      }
    });
  }
};
AssessmentBuilder.Views.List.prototype.listItemViewClass = null;
AssessmentBuilder.Views.List.prototype.listItemCssClass = "list-item-container";
